module.exports = __webpack_public_path__ + "img/1438883128.bddae602.jpg";